import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconAiCommentGray = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Frame 4792",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Union",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3.875 1.25C3.875 1.04289 3.70711 0.875 3.5 0.875C3.29289 0.875 3.125 1.04289 3.125 1.25V1.625H2.75C2.54289 1.625 2.375 1.79289 2.375 2C2.375 2.20711 2.54289 2.375 2.75 2.375H3.125V2.75C3.125 2.95711 3.29289 3.125 3.5 3.125C3.70711 3.125 3.875 2.95711 3.875 2.75V2.375H4.25C4.45711 2.375 4.625 2.20711 4.625 2C4.625 1.79289 4.45711 1.625 4.25 1.625H3.875V1.25Z",
				fill: "#E0E0E0"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Union_2",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M2.5 4.875C2.5 4.66789 2.33211 4.5 2.125 4.5C1.91789 4.5 1.75 4.66789 1.75 4.875V5.25H1.375C1.16789 5.25 1 5.41789 1 5.625C1 5.83211 1.16789 6 1.375 6H1.75V6.375C1.75 6.58211 1.91789 6.75 2.125 6.75C2.33211 6.75 2.5 6.58211 2.5 6.375V6H2.875C3.08211 6 3.25 5.83211 3.25 5.625C3.25 5.41789 3.08211 5.25 2.875 5.25H2.5V4.875Z",
				fill: "#E0E0E0"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 226 (Stroke)",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.18462 6.05815C6.4287 6.30223 6.4287 6.69796 6.18462 6.94204L1.94198 11.1847C1.6979 11.4288 1.30217 11.4288 1.05809 11.1847C0.814016 10.9406 0.814016 10.5449 1.05809 10.3008L5.30073 6.05815C5.54481 5.81407 5.94054 5.81407 6.18462 6.05815Z",
				fill: "#959595"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Star 2",
				d: "M8.55626 1.00899C8.83527 0.562725 9.52346 0.747125 9.54196 1.27311L9.57535 2.22267C9.5852 2.50265 9.80989 2.72734 10.0899 2.73718L11.0394 2.77058C11.5654 2.78908 11.7498 3.47727 11.3035 3.75628L10.4979 4.25998C10.2604 4.4085 10.1781 4.71542 10.3096 4.96281L10.7554 5.80186C11.0024 6.26663 10.4986 6.77041 10.0338 6.52344L9.1948 6.07758C8.94742 5.94612 8.64049 6.02836 8.49197 6.2659L7.98827 7.07155C7.70926 7.51782 7.02107 7.33342 7.00257 6.80743L6.96917 5.85787C6.95933 5.5779 6.73464 5.35321 6.45467 5.34336L5.5051 5.30997C4.97912 5.29147 4.79472 4.60328 5.24098 4.32427L6.04663 3.82056C6.28417 3.67205 6.36642 3.36512 6.23496 3.11773L5.7891 2.27869C5.54212 1.81392 6.04591 1.31013 6.51068 1.5571L7.34972 2.00296C7.59711 2.13442 7.90404 2.05218 8.05255 1.81464L8.55626 1.00899Z",
				fill: "#C0C0C0"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Union_3",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.5 8.375C9.5 8.16789 9.33211 8 9.125 8C8.91789 8 8.75 8.16789 8.75 8.375V8.75H8.375C8.16789 8.75 8 8.91789 8 9.125C8 9.33211 8.16789 9.5 8.375 9.5H8.75V9.875C8.75 10.0821 8.91789 10.25 9.125 10.25C9.33211 10.25 9.5 10.0821 9.5 9.875V9.5H9.875C10.0821 9.5 10.25 9.33211 10.25 9.125C10.25 8.91789 10.0821 8.75 9.875 8.75H9.5V8.375Z",
				fill: "#E0E0E0"
			})
		]
	})
});
export default SvgIconAiCommentGray;
